import React from 'react';
import PropTypes from 'prop-types';
import { SidebarCMS } from '../../basic/';
import { useSelector } from 'react-redux';

//TODO: rewrite layout, final structure should look like <div>SidebarHeader ContentHeader Sidebar Content</div>
const CMSLayout = ({ children }) => {
  const isSidebarHidden = useSelector((s) => s.localStorage.isSidebarHidden);

  let navHelperClass = isSidebarHidden ? ' menu-closed' : ' menu-opened';

  return (
    <>
      <div className={`cms-layout-page-container${navHelperClass}`}>
        <SidebarCMS />
        {children}
      </div>
    </>
  );
};

CMSLayout.propTypes = { children: PropTypes.node };

export default CMSLayout;
